import { Div, TextInput, TableBuilder, NumberInput, Link, Radio, Checkbox } from "@tblabs/truffle";
import { Box } from "../Components/Utils/Box";
import { DateTimeEditInput } from "../Components/Utils/DateSlider";
import { Icons } from "../Components/Utils/Icons";
import { DefaultIconButton } from "../Components/Utils/XPrimaryButton";
import { DeliveryForm } from "../Models/DeliveryForm";
import { ReturnForm } from "../Models/ReturnForm";
import { Discount } from "../Models/Ticket";
import { ShopContent } from "../Shop/ShopContent";
import { CustomerExperienceSelector } from "./Admin/OrderEdit/Components/CustomerExperienceSelector";
import { PaymentPresets } from "../Models/PaymentPresets";
import { TicketBasketList } from "./TicketBasketList";
import { TicketData } from "./TicketData";
import { FormRow } from "../Components/FormRow";
import { FormPrinter } from "../Components/FormPrinter";


export class TicketForm extends Div
{
    constructor(shop: ShopContent, private ticketData: TicketData)
    {
        super();

        this.Append(
            new FormPrinter(
                new FormRow("Id", new TextInput(this.ticketData.orderId)),
                new FormRow("Data utworzenia:", new DateTimeEditInput(this.ticketData.createdAt)),
                new FormRow("Produkty", new TicketBasketList(shop, this.ticketData.basketItems)),
                new FormRow("Rabaty", new Box(
                    new TableBuilder(this.ticketData.discounts)
                        .AddColumn("Nazwa", item => new TextInput(item.Name))
                        .AddColumn("Kod", item => new TextInput(item.Code))
                        .AddColumn("Wartość", item => new NumberInput(item.Value))
                        .AddColumn("Opcje", item => new Link("✖️").OnClick(() => this.ticketData.discounts.Remove(item)))
                        .Build()
                        .VisibleWhen(this.ticketData.discounts.CountRef, x => x > 0),
                    new DefaultIconButton("Dodaj rabat", Icons.Plus, () => this.ticketData.discounts.Add(new Discount({}))))),
                new FormRow("Płatność:",new Radio(this.ticketData.paymentPresets)
                        .Add(PaymentPresets.AllWithCash, "Całość gotówką przy odbiorze")
                        .Add(PaymentPresets.DepositWithBankTransfer_ServiceWithCash, "Kaucja przelewem, reszta gotówką")
                        .Add(PaymentPresets.AllWithBankTransfer, "Całość z góry przelewem")
                        .Add(PaymentPresets.AllWithCrypto, "Całość Bitcoinem z góry")
                        .Add(PaymentPresets.DepositWithBlik_ServiceWithCash, "Kaucja Blikem, reszta gotówką")),
                new FormRow("Dostawa:",
                    new Radio(this.ticketData.deliveryForm)
                        .Add(DeliveryForm.Personal, "Odbiór osobisty")
                        .Add(DeliveryForm.Package, "Dostawa kurierem")),
                new FormRow("Zwrot:",                    new Radio(this.ticketData.returnForm)
                        .Add(ReturnForm.Personal, "Zwrot osobisty")
                        .Add(ReturnForm.Package, "Zwrot paczkomatem")),
                new FormRow("Trening:", new Checkbox(this.ticketData.withTraining)),
                new FormRow("Klient:", new FormPrinter(
                    new FormRow("Imię", new TextInput(this.ticketData.customerName)),
                    new FormRow("Email", new TextInput(this.ticketData.customerEmail)),
                    new FormRow("Telefon", new TextInput(this.ticketData.customerPhone)),
                    new FormRow("Adres", new TextInput(this.ticketData.customerAddress)),
                    new FormRow("Doświadczenie", new CustomerExperienceSelector(this.ticketData.customerExperience)),
                )),
                new FormRow("Faktura:", new FormPrinter(
                    new FormRow("Wystawiać fakturę?", new Checkbox(this.ticketData.withInvoice)),
                    new FormRow("Nazwa firmy", new TextInput(this.ticketData.invoiceCompanyName)),
                    new FormRow("Adres firmy", new TextInput(this.ticketData.invoiceCompanyAddress)),
                    new FormRow("NIP firmy", new TextInput(this.ticketData.invoiceCompanyNIP)),
                )),
            ));
    }
}
